export default __webpack_public_path__ + "static/media/users.a8dc8892.svg";